// Node Modules
import React from "react";
import { withRouteData } from "react-static";

// Gobal Components
import Link from "components/link/link";
import Image from "components/image/image";

// Global Assets
import logo from "assets/images/logo.png";

// Local Components
import ComingSoon from "./components/comingSoon/comingSoon";
import ProductPreview from "./components/productPreview/productPreview";

// Local CSS
import "./products.css";
import "./products-mobile.css";

export default withRouteData(
  ({ activewearCollection, handPaintedCollection }) => {
    const renderHandPainted = () => {
      if (handPaintedCollection.products.length < 1) {
        return <ComingSoon />;
      }
      return handPaintedCollection.products.map(product => (
        <ProductPreview
          product={product}
          collection="handPainted"
          key={product.id}
        />
      ));
    };
    const renderActivewear = () => {
      if (activewearCollection.products.length < 1) {
        return <ComingSoon />;
      }
      return activewearCollection.products.map(product => (
        <ProductPreview
          product={product}
          collection="activewear"
          key={product.id}
        />
      ));
    };
    return (
      <div className="products">
        <div className="logo-container">
          <Link to="/">
            <img style={{ maxWidth: "100%" }} src={logo} />
          </Link>
        </div>
        <div className="products-column handPainted">
          <div className="outer title handPaintedTitle">
            <div className="inner rotate">
              <p>Hand-Painted</p>
            </div>
          </div>
          {renderHandPainted()}
        </div>
        <div className="products-column activewear">
          <div className="outer title activewearTitle">
            <div className="inner rotate reverse">
              <p>Activewear</p>
            </div>
          </div>

          {renderActivewear()}
        </div>
      </div>
    );
  }
);
